<template>
  <v-overlay :opacity="0.6" v-model="show" z-index="6">
    <v-dialog
      v-model="show"
      hide-overlay
      @click:outside="doCloseConfirm"
      :persistent="true"
    >
      <div class="py-5 px-8 white" id="applicant-dialog">
        <div role="button" class="close" @click="doCloseConfirm">&times;</div>
        <div
          class="text-center bg-tranparent-yellow pa-3 text-title font-weight-bold"
        >
          {{ $t("applicant_title") }}
        </div>
        <div
          class="expansion-container pt-6"
          v-if="(isEdit && session && tickets.length) || !isEdit"
        >
          <div class="py-4 px-4 px-md-0">
            <div class="primary-1--text">
              選擇票券/ Select the Type of Tickets
            </div>
            <div>
              {{ form.ticketName + `(${form.displayIndex})` }}
            </div>
          </div>
          <v-expansion-panels v-model="panel">
            <!-- 基本資料 -->
            <v-expansion-panel v-if="hasUserInfo">
              <v-expansion-panel-header
                :disabled="
                  step < steps.indexOf('userInfo') ||
                    (steps.indexOf('userInfo') === 0 && step === 0)
                "
              >
                <div class="primary-1--text">
                  基本資料/ General Information
                  <v-icon
                    v-if="!userInfoValid && step > steps.indexOf('userInfo')"
                    color="red"
                    >mdi-alert</v-icon
                  >
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-form
                  ref="userinfoForm"
                  v-model="userInfoValid"
                  fast-fail
                  @submit.prevent
                >
                  <v-container>
                    <v-row>
                      <template
                        v-if="session.applicants.properties.identityName"
                      >
                        <v-col
                          cols="12"
                          sm="6"
                          md="6"
                          id="identityName"
                          v-if="!!session.applicants.properties.identityName"
                        >
                          <v-text-field
                            label="姓名/ Name"
                            :required="
                              session.applicants.properties.identityName
                                .required
                            "
                            :disabled="
                              isEdit &&
                                !session.applicants.properties.identityName
                                  .editable
                            "
                            :append-icon="
                              isEdit &&
                              !session.applicants.properties.identityName
                                .editable
                                ? 'mdi-lock '
                                : ''
                            "
                            v-model="form.identityName"
                            @change="v => (form.identityName = v)"
                            :rules="
                              session.applicants.properties.identityName
                                .required
                                ? [isRequired, onlyEnChWord]
                                : []
                            "
                          ></v-text-field>
                        </v-col>
                        <v-col
                          cols="12"
                          sm="6"
                          md="6"
                          id="identityNumber"
                          v-if="!!session.applicants.properties.identityNumber"
                        >
                          <v-text-field
                            ref="idNumberInput"
                            label="身分證或護照/ Passport No
                          "
                            :required="
                              session.applicants.properties.identityNumber
                                .required
                            "
                            :disabled="
                              isEdit &&
                                !session.applicants.properties.identityNumber
                                  .editable
                            "
                            :append-icon="
                              isEdit &&
                              !session.applicants.properties.identityNumber
                                .editable
                                ? 'mdi-lock '
                                : ''
                            "
                            v-model="form.identityNumber"
                            :rules="
                              session.applicants.properties.identityNumber
                                .required
                                ? !!session.applicants.properties.nationality &&
                                  form.nationality === 'Taiwan (台灣)'
                                  ? [isRequired, idNumberValid, sameId]
                                  : [isRequired, onlyEnNum, sameId]
                                : []
                            "
                            @keyup="keyupSetting"
                            @input="updateIdentityNumber"
                          ></v-text-field>
                        </v-col>
                      </template>
                      <template v-else>
                        <v-col
                          cols="12"
                          sm="6"
                          md="6"
                          id="firstName"
                          v-if="!!session.applicants.properties.firstName"
                        >
                          <v-text-field
                            label="名字/ Given Name"
                            :required="
                              session.applicants.properties.firstName.required
                            "
                            :disabled="
                              isEdit &&
                                !session.applicants.properties.firstName
                                  .editable
                            "
                            :append-icon="
                              isEdit &&
                              !session.applicants.properties.firstName.editable
                                ? 'mdi-lock '
                                : ''
                            "
                            v-model="form.firstName"
                            @change="v => (form.firstName = v)"
                            :rules="
                              session.applicants.properties.firstName.required
                                ? [isRequired, onlyEnChWord]
                                : []
                            "
                          ></v-text-field>
                        </v-col>
                        <v-col
                          cols="12"
                          sm="6"
                          md="6"
                          id="lastName"
                          v-if="!!session.applicants.properties.lastName"
                        >
                          <v-text-field
                            label="姓氏/ Family Name"
                            :required="
                              session.applicants.properties.lastName.required
                            "
                            :disabled="
                              isEdit &&
                                !session.applicants.properties.lastName.editable
                            "
                            :append-icon="
                              isEdit &&
                              !session.applicants.properties.lastName.editable
                                ? 'mdi-lock '
                                : ''
                            "
                            v-model="form.lastName"
                            @change="v => (form.lastName = v)"
                            :rules="
                              session.applicants.properties.lastName.required
                                ? [isRequired, onlyEnChWord]
                                : []
                            "
                          ></v-text-field>
                        </v-col>
                        <v-col
                          cols="12"
                          sm="6"
                          md="6"
                          id="identityNumber"
                          v-if="!!session.applicants.properties.identityNumber"
                        >
                          <v-text-field
                            ref="idNumberInput"
                            label="身分證或護照/ External ID"
                            :required="
                              session.applicants.properties.identityNumber
                                .required
                            "
                            :disabled="
                              isEdit &&
                                !session.applicants.properties.identityNumber
                                  .editable
                            "
                            :append-icon="
                              isEdit &&
                              !session.applicants.properties.identityNumber
                                .editable
                                ? 'mdi-lock '
                                : ''
                            "
                            v-model="form.identityNumber"
                            :rules="
                              session.applicants.properties.identityNumber
                                .required
                                ? !!session.applicants.properties.nationality &&
                                  form.nationality === 'Taiwan (台灣)'
                                  ? [isRequired, idNumberValid, sameId]
                                  : [isRequired, onlyEnNum, sameId]
                                : []
                            "
                            @input="updateIdentityNumber"
                          ></v-text-field>
                        </v-col>
                      </template>
                      <v-col
                        cols="12"
                        sm="6"
                        md="6"
                        id="nationality"
                        v-if="!!session.applicants.properties.nationality"
                      >
                        <v-select
                          :items="countries"
                          label="國籍/地區  Nationality/Region"
                          v-model="form.nationality"
                          @change="
                            v => {
                              this.form.nationality = v;
                            }
                          "
                          :rules="
                            session.applicants.properties.nationality.required
                              ? [isRequired]
                              : []
                          "
                          :disabled="
                            isEdit &&
                              !session.applicants.properties.nationality
                                .editable
                          "
                          :append-icon="
                            isEdit &&
                            !session.applicants.properties.nationality.editable
                              ? 'mdi-lock '
                              : ''
                          "
                        ></v-select>
                      </v-col>
                      <v-col
                        cols="12"
                        sm="6"
                        md="6"
                        id="birthday"
                        v-if="!!session.applicants.properties.birthday"
                      >
                        <div class="d-flex align-center">
                          <v-menu
                            ref="birthdayMenu"
                            :close-on-content-click="false"
                            :return-value.sync="birthday"
                            transition="scale-transition"
                            :disabled="
                              isEdit &&
                                !session.applicants.properties.birthday.editable
                            "
                            offset-y
                            min-width="auto"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                v-model="form.birthday"
                                :rules="
                                  session.applicants.properties.birthday
                                    .required
                                    ? [isRequired]
                                    : []
                                "
                                :required="
                                  session.applicants.properties.birthday
                                    .required
                                "
                                label="出生日期/ Date of Birth (yyyy/mm/dd)"
                                :disabled="
                                  isEdit &&
                                    !session.applicants.properties.birthday
                                      .editable
                                "
                                :append-icon="
                                  isEdit &&
                                  !session.applicants.properties.birthday
                                    .editable
                                    ? 'mdi-lock '
                                    : 'mdi-calendar'
                                "
                                color="primary"
                                hide-details=""
                                readonly
                                v-bind="attrs"
                                v-on="on"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="form.birthday"
                              no-title
                              scrollable
                              color="primary"
                              @change="$refs.birthdayMenu.save(birthday)"
                            >
                            </v-date-picker>
                          </v-menu>
                        </div>
                      </v-col>
                      <v-col
                        cols="12"
                        sm="6"
                        md="6"
                        id="age"
                        v-if="!!session.applicants.properties.age"
                      >
                        <v-text-field
                          label="年齡/Age"
                          type="tel"
                          v-model="form.age"
                          :required="session.applicants.properties.age.required"
                          :rules="
                            session.applicants.properties.age.required
                              ? [isRequired, isNumber]
                              : [isNumber]
                          "
                          :disabled="
                            isEdit &&
                              !session.applicants.properties.age.editable
                          "
                          :append-icon="
                            isEdit &&
                            !session.applicants.properties.age.editable
                              ? 'mdi-lock '
                              : ''
                          "
                        ></v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                        id="gender"
                        v-if="!!session.applicants.properties.gender"
                      >
                        <v-radio-group
                          v-model="form.gender"
                          row
                          :disabled="
                            isEdit &&
                              !session.applicants.properties.gender.editable
                          "
                        >
                          <template v-slot:label>
                            <div>性別/ Gender</div>
                          </template>
                          <v-radio label="男/Male" value="M"></v-radio>
                          <v-radio label="女/Female" value="F"></v-radio>
                        </v-radio-group>
                      </v-col>
                      <v-col
                        cols="12"
                        sm="12"
                        md="12"
                        id="phoneNumber"
                        v-if="!!session.applicants.properties.phoneNumber"
                      >
                        <div class="d-none">
                          <v-text-field
                            v-model="form.tempphoneNumber"
                            :required="
                              session.applicants.properties.phoneNumber.required
                            "
                            :rules="
                              session.applicants.properties.phoneNumber.required
                                ? [isRequired]
                                : []
                            "
                          />
                        </div>
                        <VuePhoneNumberInput
                          :class="!phoneValid ? 'error--text' : ''"
                          error-color="#ff0032"
                          :no-flags="true"
                          ref="phoneInputRef"
                          :disabled="
                            isEdit &&
                              !session.applicants.properties.phoneNumber
                                .editable
                          "
                          :error="
                            session.applicants.properties.phoneNumber
                              .required &&
                              (form.tempphoneNumber === '' ||
                                !form.tempphoneNumber)
                          "
                          :append-icon="
                            isEdit &&
                            !session.applicants.properties.phoneNumber.editable
                              ? 'mdi-lock '
                              : ''
                          "
                          :translations="{
                            countrySelectorLabel: $t('country_code'),
                            phoneNumberLabel: $t('login_phone_field')
                          }"
                          :required="
                            session.applicants.properties.phoneNumber.required
                          "
                          @update="
                            obj => phoneNumberUpdate('tempphoneNumber', obj)
                          "
                          v-model="form.tempphoneNumber"
                        />
                        <v-icon
                          class="is-phone-lock"
                          v-if="
                            isEdit &&
                              !session.applicants.properties.phoneNumber
                                .editable
                          "
                          >mdi-lock</v-icon
                        >
                        <div
                          v-if="
                            session.applicants.properties.phoneNumber
                              .required &&
                              (form.tempphoneNumber === '' ||
                                !form.tempphoneNumber)
                          "
                          class="v-messages error--text mt-1"
                          role="alert"
                        >
                          <div class="v-messages__wrapper">
                            <div class="v-messages__message">
                              {{
                                $t(
                                  !form.tempphoneNumber ||
                                    form.tempphoneNumber === ""
                                    ? "form_required"
                                    : "applicant_phone_invalid_text"
                                )
                              }}
                            </div>
                          </div>
                        </div>
                      </v-col>
                      <v-col
                        cols="12"
                        sm="12"
                        md="12"
                        id="address"
                        v-if="!!session.applicants.properties.address"
                      >
                        <v-text-field
                          label="地址/ Address"
                          v-model="form.address"
                          :rules="
                            session.applicants.properties.address.required
                              ? [isRequired]
                              : []
                          "
                          :disabled="
                            isEdit &&
                              !session.applicants.properties.address.editable
                          "
                          :append-icon="
                            isEdit &&
                            !session.applicants.properties.address.editable
                              ? 'mdi-lock '
                              : ''
                          "
                        ></v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                        sm="12"
                        md="12"
                        id="email"
                        v-if="!!session.applicants.properties.email"
                      >
                        <v-text-field
                          label="電子信箱/ E-mail"
                          type="email"
                          v-model="form.email"
                          :rules="
                            session.applicants.properties.email.required
                              ? [isRequired, isEmail]
                              : []
                          "
                          :disabled="
                            isEdit &&
                              !session.applicants.properties.email.editable
                          "
                          :append-icon="
                            isEdit &&
                            !session.applicants.properties.email.editable
                              ? 'mdi-lock '
                              : ''
                          "
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-container>
                  <div class="expansion-action">
                    <v-btn
                      v-if="
                        !session.applicants.properties.worldgymId &&
                          !session.applicants.properties.shirtSize &&
                          !customFields.length &&
                          !session.applicants.properties
                            .emergencyContactPerson &&
                          !session.applicants.properties
                            .emergencyContactRelation &&
                          !session.applicants.properties
                            .emergencyContactPhoneNumber
                      "
                      :disabled="isInvalid || (isEdit && !hasDiff)"
                      :class="{
                        disabledBtn: isInvalid || (isEdit && !hasDiff)
                      }"
                      class="nextBtn"
                      depressed
                      :x-large="!$vuetify.breakpoint.xs"
                      @click="e => this.submit('userInfo')"
                      >{{ $t("applicant_form_complete") }}</v-btn
                    >
                    <v-btn
                      v-else
                      :disabled="!userInfoValid"
                      :class="{ disabledBtn: !userInfoValid }"
                      class="nextBtn"
                      depressed
                      :x-large="!$vuetify.breakpoint.xs"
                      @click="nextStep('userInfo')"
                      >{{ $t("next_step") }}</v-btn
                    >
                  </div>
                </v-form>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <!-- 緊急聯絡資訊 -->
            <v-expansion-panel
              v-if="
                session.applicants.properties.emergencyContactPerson ||
                  session.applicants.properties.emergencyContactRelation ||
                  session.applicants.properties.emergencyContactPhoneNumber
              "
            >
              <v-expansion-panel-header
                :disabled="
                  step < steps.indexOf('emergency') ||
                    (steps.indexOf('emergency') === 0 && step === 0)
                "
              >
                <div class="primary-1--text">
                  緊急聯絡資訊/ Emergency Contact Information
                  <v-icon
                    v-if="!emergencyValid && step > steps.indexOf('emergency')"
                    color="red"
                    >mdi-alert</v-icon
                  >
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-form
                  ref="emergencyForm"
                  v-model="emergencyValid"
                  fast-fail
                  @submit.prevent
                >
                  <v-container>
                    <v-row>
                      <v-col
                        cols="12"
                        sm="12"
                        md="12"
                        id="emergencyContactPerson"
                        v-if="
                          session.applicants.properties.emergencyContactPerson
                        "
                      >
                        <v-text-field
                          label="緊急聯絡人/ Emergency Contact"
                          v-model="form.emergencyContactPerson"
                          :required="
                            session.applicants.properties.emergencyContactPerson
                              .required
                          "
                          :rules="
                            session.applicants.properties.emergencyContactPerson
                              .required
                              ? [isRequired]
                              : []
                          "
                          :disabled="
                            isEdit &&
                              !session.applicants.properties
                                .emergencyContactPerson.editable
                          "
                          :append-icon="
                            isEdit &&
                            !session.applicants.properties
                              .emergencyContactPerson.editable
                              ? 'mdi-lock '
                              : ''
                          "
                        ></v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                        sm="12"
                        md="12"
                        id="emergencyContactRelation"
                        v-if="
                          !!session.applicants.properties
                            .emergencyContactRelation
                        "
                      >
                        <v-text-field
                          label="緊急聯絡人關係/ Emergency Contact relationship"
                          v-model="form.emergencyContactRelation"
                          :required="
                            session.applicants.properties
                              .emergencyContactRelation.required
                          "
                          :rules="
                            session.applicants.properties
                              .emergencyContactRelation.required
                              ? [isRequired]
                              : []
                          "
                          :disabled="
                            isEdit &&
                              !session.applicants.properties
                                .emergencyContactRelation.editable
                          "
                          :append-icon="
                            isEdit &&
                            !session.applicants.properties
                              .emergencyContactRelation.editable
                              ? 'mdi-lock '
                              : ''
                          "
                        ></v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                        sm="12"
                        md="12"
                        id="emergencyContactPhoneNumber"
                        v-if="
                          !!session.applicants.properties
                            .emergencyContactPhoneNumber
                        "
                      >
                        <div class="d-none">
                          <v-text-field
                            v-model="form.tempemergencyContactPhoneNumber"
                            :required="
                              session.applicants.properties
                                .emergencyContactPhoneNumber.required
                            "
                            :rules="
                              session.applicants.properties
                                .emergencyContactPhoneNumber.required
                                ? [isRequired]
                                : []
                            "
                          />
                        </div>
                        <VuePhoneNumberInput
                          :class="!emergencyPhoneValid ? 'error--text' : ''"
                          :no-flags="true"
                          ref="emergencyPhoneInputRef"
                          :disabled="
                            isEdit &&
                              !session.applicants.properties
                                .emergencyContactPhoneNumber.editable
                          "
                          :rules="
                            session.applicants.properties
                              .emergencyContactPhoneNumber.required
                              ? [isRequired]
                              : []
                          "
                          :append-icon="
                            isEdit &&
                            !session.applicants.properties
                              .emergencyContactPhoneNumber.editable
                              ? 'mdi-lock '
                              : ''
                          "
                          @update="
                            obj =>
                              phoneNumberUpdate(
                                'tempemergencyContactPhoneNumber',
                                obj
                              )
                          "
                          :error-color="'#ff0032'"
                          :translations="{
                            countrySelectorLabel: $t('country_code'),
                            phoneNumberLabel:
                              '緊急聯絡人電話/Emergency Contact phone number',
                            example: 'Exemple :'
                          }"
                          :required="
                            session.applicants.properties
                              .emergencyContactPhoneNumber.required
                          "
                          v-model="form.tempemergencyContactPhoneNumber"
                        />
                        <div
                          v-if="!emergencyPhoneValid"
                          class="v-messages error--text mt-1"
                          role="alert"
                        >
                          <div class="v-messages__wrapper">
                            <div class="v-messages__message">
                              {{
                                $t(
                                  form.emergencyContactPhoneNumber === ""
                                    ? "form_required"
                                    : "applicant_phone_invalid_text"
                                )
                              }}
                            </div>
                          </div>
                        </div>
                      </v-col>
                    </v-row>
                  </v-container>
                  <div class="expansion-action">
                    <v-btn
                      v-if="
                        !session.applicants.properties.worldgymId &&
                          !session.applicants.properties.shirtSize &&
                          !customFields.length
                      "
                      :disabled="isInvalid || (isEdit && !hasDiff)"
                      :class="{
                        disabledBtn: isInvalid || (isEdit && !hasDiff)
                      }"
                      class="nextBtn"
                      depressed
                      :x-large="!$vuetify.breakpoint.xs"
                      @click="e => this.submit('emergency')"
                      >{{ $t("applicant_form_complete") }}</v-btn
                    >
                    <v-btn
                      v-else
                      class="nextBtn"
                      depressed
                      :disabled="!emergencyValid"
                      :class="{ disabledBtn: !emergencyValid }"
                      :x-large="!$vuetify.breakpoint.xs"
                      @click="nextStep('emergency')"
                      >{{ $t("next_step") }}</v-btn
                    >
                  </div>
                </v-form>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <!-- 其他資訊 -->
            <v-expansion-panel v-if="!!customFields.length">
              <v-expansion-panel-header
                :disabled="
                  step < steps.indexOf('custom') ||
                    (steps.indexOf('custom') === 0 && step === 0)
                "
              >
                <div class="primary-1--text">
                  其他資訊 / Other Information
                  <v-icon
                    v-if="!customValid && step > steps.indexOf('custom')"
                    color="red"
                    >mdi-alert</v-icon
                  >
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-form
                  ref="otherForm"
                  v-model="customValid"
                  fast-fail
                  @submit.prevent
                >
                  <v-container>
                    <v-row v-for="(field, i) in customFields">
                      <v-col>
                        <v-text-field
                          :id="field.name"
                          :label="field.label"
                          :v-model="form[field.name]"
                          :value="field.value"
                          @change="v => (form[field.name] = v)"
                          :required="
                            session.applicants.properties[field.name].required
                          "
                          :rules="
                            session.applicants.properties[field.name].required
                              ? [isRequired]
                              : []
                          "
                          :disabled="isEdit && !field.editable"
                          :append-icon="
                            isEdit && !field.editable ? 'mdi-lock ' : ''
                          "
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-container>
                  <div class="expansion-action">
                    <v-btn
                      v-if="
                        !session.applicants.properties.worldgymId &&
                          !session.applicants.properties.shirtSize
                      "
                      :disabled="isInvalid || (isEdit && !hasDiff)"
                      :class="{
                        disabledBtn: isInvalid || (isEdit && !hasDiff)
                      }"
                      class="nextBtn"
                      depressed
                      :x-large="!$vuetify.breakpoint.xs"
                      @click="e => this.submit('custom')"
                      >{{ $t("applicant_form_complete") }}</v-btn
                    >
                    <v-btn
                      v-else
                      class="nextBtn"
                      depressed
                      :disabled="!customValid"
                      :class="{ disabledBtn: !customValid }"
                      :x-large="!$vuetify.breakpoint.xs"
                      @click="nextStep('custom')"
                      >{{ $t("next_step") }}</v-btn
                    >
                  </div>
                </v-form>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <!-- 衣服尺寸 -->
            <v-expansion-panel v-if="!!session.applicants.properties.shirtSize">
              <v-expansion-panel-header
                :disabled="
                  step < steps.indexOf('shirtSize') ||
                    (steps.indexOf('shirtSize') === 0 && step === 0)
                "
              >
                <div class="primary-1--text">
                  衣服尺寸/ Shirt Size
                  <v-icon
                    v-if="!shirtSizeValid && step > steps.indexOf('shirtSize')"
                    color="red"
                    >mdi-alert</v-icon
                  >
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-form ref="shirtForm" v-model="shirtSizeValid">
                  <v-container>
                    <v-row>
                      <v-col>
                        <v-radio-group
                          v-model="form.shirtSize"
                          row
                          :required="
                            session.applicants.properties.shirtSize.required
                          "
                          :rules="
                            session.applicants.properties.shirtSize.required
                              ? [isRequired]
                              : []
                          "
                          :disabled="
                            isEdit &&
                              !session.applicants.properties.shirtSize.editable
                          "
                        >
                          <template v-slot:label>
                            <div>衣服尺寸/ Shirt Size</div>
                          </template>
                          <v-radio label="XS" value="XS"></v-radio>
                          <v-radio label="S" value="S"></v-radio>
                          <v-radio label="M" value="M"></v-radio>
                          <v-radio label="L" value="L"></v-radio>
                          <v-radio label="XL" value="XL"></v-radio>
                          <v-radio label="2XL" value="2XL"></v-radio>
                        </v-radio-group>
                      </v-col>
                    </v-row>
                  </v-container>
                  <div class="expansion-action">
                    <v-btn
                      v-if="!session.applicants.properties.worldgymId"
                      class="nextBtn"
                      depressed
                      :disabled="isInvalid || (isEdit && !hasDiff)"
                      :class="{
                        disabledBtn: isInvalid || (isEdit && !hasDiff)
                      }"
                      :x-large="!$vuetify.breakpoint.xs"
                      @click="e => this.submit('shirtSize')"
                      >{{ $t("applicant_form_complete") }}</v-btn
                    >
                    <v-btn
                      v-else
                      class="nextBtn"
                      :disabled="!shirtSizeValid"
                      :class="{ disabledBtn: !shirtSizeValid }"
                      depressed
                      :x-large="!$vuetify.breakpoint.xs"
                      @click="nextStep('shirtSize')"
                      >{{ $t("next_step") }}</v-btn
                    >
                  </div>
                </v-form>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <!-- World Gym ID -->
            <v-expansion-panel
              v-if="!!session.applicants.properties.worldgymId"
            >
              <v-expansion-panel-header
                :disabled="
                  step < steps.indexOf('worldgym') ||
                    (steps.indexOf('worldgym') === 0 && step === 0)
                "
              >
                <div class="primary-1--text">
                  World Gym ID/ World Gym ID
                  <v-icon
                    v-if="
                      !worldGymFormValid && step > steps.indexOf('worldgym')
                    "
                    color="red"
                    >mdi-alert</v-icon
                  >
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-form ref="worldgymForm" v-model="worldGymFormValid">
                  <v-container>
                    <v-row>
                      <v-col>
                        <v-text-field
                          v-model="form.worldgymId"
                          label="請輸入您的 World Gym ID"
                          :required="
                            session.applicants.properties.worldgymId.required
                          "
                          :rules="
                            session.applicants.properties.worldgymId.required
                              ? [isRequired]
                              : []
                          "
                          :disabled="
                            isEdit &&
                              !session.applicants.properties.worldgymId.editable
                          "
                        />
                      </v-col>
                    </v-row>
                  </v-container>
                  <div class="expansion-action">
                    <v-btn
                      class="nextBtn"
                      :disabled="isInvalid || (isEdit && !hasDiff)"
                      :class="{
                        disabledBtn: isInvalid || (isEdit && !hasDiff)
                      }"
                      depressed
                      :x-large="!$vuetify.breakpoint.xs"
                      @click="e => this.submit('worldGym')"
                      >{{ $t("applicant_form_complete") }}</v-btn
                    >
                  </div>
                </v-form>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </div>
      </div>
    </v-dialog>
  </v-overlay>
</template>

<script>
import DatePicker from "@/views/auth/components/DatePicker.vue";
import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";
import { mapActions, mapGetters } from "vuex";
import TM from "@/api/ticket-management";
import { countryList } from "@/vendor/country";

export default {
  components: {
    DatePicker,
    VuePhoneNumberInput
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    selectedIdx: {
      type: Number,
      default: -1
    },
    applicant: {
      type: Object,
      default: {}
    },
    applicants: {
      type: Array,
      default: () => []
    },
    tickets: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      countries: countryList.map(c => c.name),
      panel: 0,
      step: 1,
      steps: [],
      isLockAll: true,
      formElem: {
        userInfo: [
          "identityName",
          "firstName",
          "lastName",
          "identityNumber",
          "nationality",
          "birthday",
          "age",
          "gender",
          "phoneNumber",
          "address",
          "email"
        ],
        emergency: [
          "emergencyContactPerson",
          "emergencyContactRelation",
          "emergencyContactPhoneNumber"
        ],
        custom: [],
        shirtSize: ["shirtSize"]
      },
      customFields: [],
      appliData: this.applicant,
      items: this.tickets.map(t => t.name),
      isConfirmDialogShow: false,
      confirmToClose: false,
      ticketFormValid: false,
      userInfoValid: true,
      customValid: true,
      emergencyValid: true,
      shirtSizeValid: true,
      worldGymFormValid: true,
      phoneValid: true,
      emergencyPhoneValid: true,
      form: {
        tempphoneCountry: "",
        tempemergencyContactPhoneCountry: "",
        tempphoneNumber: "",
        tempemergencyContactPhoneNumber: "",
        ticket: "",
        firstName: "",
        lastName: "",
        identityName: "",
        identityNumber: "",
        nationality: "",
        birthday: "",
        age: "",
        gender: "",
        phoneNumber: "",
        address: "",
        email: "",
        emergencyContactPerson: "",
        emergencyContactRelation: "",
        emergencyContactPhoneNumber: "",
        shirtSize: "",
        worldgymId: ""
      },
      products: [],
      ticketOption: []
    };
  },
  watch: {
    show: {
      immediate: true,
      deep: true,
      handler(newVal, val) {
        if (newVal !== val) {
          if (newVal) {
            this.panel = 0;
            this.step = 0;
            this.setFormElem();
            this.$forceUpdate();
            let form = { ...this.appliData };

            if (this.appliData.phoneNumber) {
              let phone = this.appliData.phoneNumber.indexOf(" ");
              let hasCountryCode =
                phone > -1 && this.appliData.phoneNumber.indexOf("+") > -1;
              form = {
                ...form,
                tempphoneNumber: hasCountryCode
                  ? this.appliData.phoneNumber.slice(phone + 1)
                  : this.appliData.phoneNumber,
                tempphoneCountry: hasCountryCode
                  ? this.appliData.phoneNumber.split(" ")[0]
                  : null
              };
            }

            if (this.appliData.emergencyContactPhoneNumber) {
              let emphone = this.appliData.emergencyContactPhoneNumber.indexOf(
                " "
              );
              let emHasCountryCode =
                emphone > -1 && this.appliData.phoneNumber.indexOf("+") > -1;
              form = {
                ...form,
                tempemergencyContactPhoneNumber: emHasCountryCode
                  ? this.appliData.emergencyContactPhoneNumber.slice(
                      emphone + 1
                    )
                  : this.appliData.emergencyContactPhoneNumber,
                tempemergencyContactPhoneCountry: emHasCountryCode
                  ? this.appliData.emergencyContactPhoneNumber.split(" ")[0]
                  : null
              };
            }

            this.setForm(form);
          } else {
            this.form = {
              tempphoneCountry: "",
              tempphoneNumber: "",
              tempemergencyContactPhoneCountry: "",
              tempemergencyContactPhoneNumber: "",
              ticket: "",
              firstName: "",
              lastName: "",
              identityName: "",
              identityNumber: "",
              nationality: "",
              birthday: "",
              age: "",
              gender: "",
              phoneNumber: "",
              address: "",
              email: "",
              emergencyContactPerson: "",
              emergencyContactRelation: "",
              emergencyContactPhoneNumber: "",
              shirtSize: "",
              worldgymId: ""
            };
          }
          this.$forceUpdate();
        }
      }
    },
    step: {
      immediate: true,
      deep: true,
      async handler(v, o) {
        await this.$nextTick();
        this.$forceUpdate();

        if (
          this.steps[v] === "emergency" &&
          this.form.tempemergencyContactPhoneCountry &&
          this.form.tempemergencyContactPhoneCountry !== "" &&
          this.show
        ) {
          setTimeout(() => {
            let code = countryList.find(
              c =>
                this.form.tempemergencyContactPhoneCountry === `+${c.dialCode}`
            );
            this.$refs.emergencyPhoneInputRef.countryCode = code.iso2;
          }, 200);
        }
        if (
          this.steps[v] === "userInfo" &&
          this.form.tempphoneCountry &&
          this.form.tempphoneCountry !== "" &&
          this.show
        ) {
          setTimeout(() => {
            let code = countryList.find(
              c => this.form.tempphoneCountry === `+${c.dialCode}`
            );
            this.$refs.phoneInputRef.countryCode = code.iso2;
          }, 200);
        }

        if (
          this.steps[v] === "userInfo" &&
          this.show &&
          this.$refs.userinfoForm
        ) {
          setTimeout(() => {
            this.$refs.userinfoForm.validate();
          }, 200);
        }
      }
    },
    form: {
      immediate: true,
      deep: true,
      async handler(v, o) {
        if (this.show && this.$refs.userinfoForm) {
          await this.$nextTick();
          this.$refs.userinfoForm.validate();
        }
      }
    },
    appliData: {
      immediate: true,
      deep: true,
      handler(newVal, val) {
        let newIdx = newVal ? newVal.index : null;
        let oldIdx = val ? val.index : null;
        if (newIdx !== oldIdx) {
          this.form = {
            tempphoneCountry: "",
            tempphoneNumber: "",
            tempemergencyContactPhoneCountry: "",
            tempemergencyContactPhoneNumber: "",
            ticket: "",
            firstName: "",
            lastName: "",
            identityName: "",
            identityNumber: "",
            nationality: "",
            birthday: "",
            age: "",
            gender: "",
            phoneNumber: "",
            address: "",
            email: "",
            emergencyContactPerson: "",
            emergencyContactRelation: "",
            emergencyContactPhoneNumber: "",
            shirtSize: "",
            worldgymId: ""
          };

          let form = { ...newVal };

          if (this.appliData.phoneNumber) {
            let phone = this.appliData.phoneNumber.indexOf(" ");
            let hasCountryCode =
              phone > -1 && this.appliData.phoneNumber.indexOf("+") > -1;
            form = {
              ...form,
              tempphoneNumber: hasCountryCode
                ? this.appliData.phoneNumber.slice(phone + 1)
                : this.appliData.phoneNumber,
              tempphoneCountry: hasCountryCode
                ? this.appliData.phoneNumber.split(" ")[0]
                : null
            };
          }

          if (this.appliData.emergencyContactPhoneNumber) {
            let emphone = this.appliData.emergencyContactPhoneNumber.indexOf(
              " "
            );
            let emHasCountryCode =
              emphone > -1 && this.appliData.phoneNumber.indexOf("+") > -1;
            form = {
              ...form,
              tempemergencyContactPhoneNumber: emHasCountryCode
                ? this.appliData.emergencyContactPhoneNumber.slice(emphone + 1)
                : this.appliData.emergencyContactPhoneNumber,
              tempemergencyContactPhoneCountry: emHasCountryCode
                ? this.appliData.emergencyContactPhoneNumber.split(" ")[0]
                : null
            };
          }

          this.setForm(form);

          this.$forceUpdate();
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      session: "session/sessionInfo",
      reserveResponse: "order/reserveResponse",
      sessionInfo: "session/sessionInfo"
    }),
    hasEmpty() {
      let hasEmpty = false;
      for (let key in this.form) {
        if (key.indexOf("temp") === -1 && key !== "ticket") {
          if (
            this.session.applicants.properties.hasOwnProperty(key) &&
            this.form[key] === ""
          ) {
            hasEmpty = true;
          }
        }
      }
      return hasEmpty;
    },
    hasDiff() {
      if (!this.isEdit) return false;
      else {
        let hasDiff = false;
        for (let key in this.form) {
          if (key.indexOf("temp") === -1 && key !== "ticket") {
            if (this.form[key] !== this.applicant[key]) {
              hasDiff = true;
            }
          }
        }
        return hasDiff;
      }
    },
    hasUserInfo() {
      let hasUserInfo = false;
      if (this.session && this.session.applicants) {
        for (var i in this.session.applicants.properties) {
          if (this.formElem.userInfo.includes(i)) {
            hasUserInfo = true;
          }
        }
      }
      return hasUserInfo;
    },
    hasEditable() {
      let hasEdit = false;
      let props = this.sessionInfo.applicants.properties;
      for (let key in props) {
        if (props[key].editable) hasEdit = true;
      }
      return hasEdit;
    },
    isInvalid() {
      let result = false;
      for (let i in this.steps) {
        if (!this[`${this.steps[i]}Valid`]) {
          result = true;
        }
      }
      return result;
    }
  },
  methods: {
    ...mapActions({
      showDialog: "dialog/show"
    }),
    toASCII(str) {
      /**
       * 轉半形字元
       */
      return str
        .replace(/[\uff01-\uff5e]/g, function(ch) {
          return String.fromCharCode(ch.charCodeAt(0) - 0xfee0);
        })
        .replace(/\u3000/g, " ");
    },
    keyupSetting() {
      this.form.identityNumber = this.toASCII(
        this.form.identityNumber
      ).toUpperCase();
    },
    updateIdentityNumber(v, e) {
      if (window.event.inputType === "insertCompositionText") return;
      this.form.identityNumber = this.toASCII(
        this.form.identityNumber
      ).toUpperCase();
    },
    onlyEnChWord(v) {
      return /^[\s\u4e00-\u9fa5_a-zA-Z]+$/.test(v) || "請輸入中文或英文";
    },
    onlyEnNum(v) {
      return /^[a-zA-Z0-9]+$/.test(v) || "請輸入英文或數字";
    },
    idNumberValid: value => {
      var reg = /^[A-Z]{1}[1-2]{1}[0-9]{8}$/; //身份證的正規表示式;
      // 小寫可過
      if (!value || value === "") return "id_number_validation";
      if (reg.test(value.toUpperCase())) {
        var s = "ABCDEFGHIJKLMNOPQRSTUVWXYZ"; //把 A 取代成 10,把 B 取代成 11...的作法
        var ct = [
          "10",
          "11",
          "12",
          "13",
          "14",
          "15",
          "16",
          "17",
          "34",
          "18",
          "19",
          "20",
          "21",
          "22",
          "35",
          "23",
          "24",
          "25",
          "26",
          "27",
          "28",
          "29",
          "32",
          "30",
          "31",
          "33"
        ];

        var i = s.indexOf(value.toUpperCase().charAt(0));
        var tempuserid = ct[i] + value.substr(1, 9); //若此身份證號若是A123456789=>10123456789
        var num = tempuserid.charAt(0) * 1;

        for (i = 1; i <= 9; i++) {
          num = num + tempuserid.charAt(i) * (10 - i);
        }

        num += tempuserid.charAt(10) * 1;
        // console.log(`return: ${num % 10 === 0 || 'id_number_validation'}`)
        return num % 10 === 0 || "請檢查身分證字號格式";
      }
      // console.log(`return: id_number_validation`)
      return "請檢查身分證字號格式";
    },
    isRequired(v) {
      return !!v || "必填";
    },
    sameId(v) {
      const filter = this.applicants.filter(
        a => a.identityNumber === v && a.index !== this.applicant.index
      );
      return !filter.length || "身分證字號重複";
    },
    isNumber(v) {
      return /^[0-9]{1,2}$/.test(v) || "請輸入數字";
    },
    isEmail(v) {
      return /.+@.+\..+/.test(v) || "請輸入正確的 Email";
    },
    doCloseConfirm() {
      let formData = {
        ...this.form
      };

      if (
        (this.isEdit && (this.hasDiff || this.hasEmpty)) ||
        (!this.isEdit &&
          (!this.userInfoValid ||
            !this.emergencyValid ||
            !this.customValid ||
            !this.shirtSizeValid))
      ) {
        this.$emit("beforeClose", { ...formData, isComplete: false });
      } else {
        this.$emit("close", { ...formData, isComplete: true });
      }
      return;
    },
    phoneNumberUpdate(name, obj) {
      if (name === "tempphoneNumber") {
        // this.form.tempphoneCountry = `+${obj?.countryCallingCode}`;
        this.form.tempphoneNumber = obj?.phoneNumber || "";
        this.form.phoneNumber = obj?.formatInternational || "";
      } else {
        // this.form.tempemergencyContactPhoneCountry = `+${obj?.countryCallingCode}`;
        this.form.tempemergencyContactPhoneNumber = obj?.phoneNumber || "";
        this.form.emergencyContactPhoneNumber = obj?.formatInternational || "";
      }
    },
    setForm(newVal) {
      for (var i in newVal) {
        let val = newVal[i];
        this.form[i] = val;
        if (i.indexOf("custom") > -1) {
          this.customFields.forEach(v => {
            if (v.name === i) v.value = val;
          });
        }
      }
    },
    anchorToAlert(elem) {
      window.event.preventDefault();
      let input =
        elem.tagName === "INPUT"
          ? elem
          : elem.querySelector("input") || elem.querySelector("select");
      if (["phoneNumber", "emergencyContactPhoneNumber"].includes(elem.id))
        input = elem.querySelector(".input-tel__input");
      document.querySelector("#applicant-dialog").parentElement.scrollTo({
        left: 0,
        top: elem.offsetTop - 100,
        behavior: "smooth"
      });

      input.focus();
    },
    async submit(cate) {
      if (!this[`${cate}Valid`]) {
        for (let i in this.formElem[cate]) {
          let c = this.formElem[cate][i];
          let invalid = false;

          if (["phoneNumber", "emergencyContactPhoneNumber"].includes(c))
            invalid = !this.form[`temp${c}`] || this.form[`temp${c}`] === "";
          else invalid = this.form[c] === "";

          if (this.session.applicants.properties[c].required && invalid) {
            let elem = document.querySelector(`#${c}`);
            this.anchorToAlert(elem);
            break;
          }
        }
        return;
      }

      if (
        // !this.isEdit && this.form.identityNumber === this.applicant.identityNumber ||
        this.isEdit &&
        !this.hasEditable
      ) {
        this.$emit("close", {
          ...this.form,
          index: this.applicant.index,
          ticketName: this.applicant.ticketName,
          isComplete: true
        });
        return;
      }
      if (this.isEdit && this.hasEditable) {
        this.$emit("submit", {
          data: {
            ...this.form,
            age: Number(this.form.age)
          },
          index: this.applicant.index,
          ticketName: this.applicant.ticketName,
          isComplete: true
        });
      } else {
        let formData = {
          ...this.form,
          age: Number(this.form.age)
        };

        delete formData.ticket;
        delete formData.index;
        delete formData.displayIndex;
        delete formData.isComplete;
        delete formData.tempemergencyContactPhoneNumber;
        delete formData.tempemergencyContactPhoneCountry;
        delete formData.tempphoneNumber;
        delete formData.tempphoneCountry;
        delete formData.ticketName;

        let updateParams = {
          orderId: this.reserveResponse.orderId,
          index: this.applicant.index,
          newApplicant: {
            ...formData
          }
        };
        const { data: updateResponse } = await TM.updateApplicants(
          updateParams
        );

        if (updateResponse.errCode === "00") {
          // debugger
          this.$emit("close", {
            ...formData,
            displayIndex: this.applicant.displayIndex,
            index: this.applicant.index,
            ticketName: this.applicant.ticketName,
            isComplete: true
          });
        } else {
          this.showDialog({
            alert: true,
            content: `<div class="pa-6 text-center font-weight-bold">
              <img
                src="/image/ic-warning@3x.png"
                alt=""
                style="width:80px"
              />
              <div class="mt-5">${this.$t(
                updateResponse.errCode === "101"
                  ? "error_with_no_outstanding_order"
                  : "duplicate_id_number"
              )}</div>
            </div>`
          });
        }
      }
      this.step = 0;
      this.panel = 0;
    },
    nextStep(type) {
      let cate = this.steps[this.step];
      // this.$refs.phoneInputRef.countryCallingCode = this.form.tempphoneCountry;
      // this.$refs.emergencyPhoneInputRef.countryCallingCode = this.form.tempemergencyContactPhoneCountry;
      if (this.step && !this[`${cate}Valid`]) {
        for (let i in this.formElem[cate]) {
          let c = this.formElem[cate][i];
          let invalid = false;
          const appliItem = this.session.applicants.properties[c];
          // if(['age'].includes(c)) invalid = (/\d\d/).test(this.form[c])
          if (["phoneNumber", "emergencyContactPhoneNumber"].includes(c))
            invalid = !this.form[`temp${c}`] || this.form[`temp${c}`] === "";
          else invalid = this.form[c] === "";
          if (appliItem && appliItem.required && invalid) {
            let elem = document.querySelector(`#${c}`);
            this.anchorToAlert(elem);
            break;
          }
        }
        // return;
      }
      if (type === cate) this.step++;
      this.panel++;
    },
    emitUpdateDate(date) {
      this.form.birthday = date;
    },
    setFormElem() {
      let name = [];
      for (var i in this.session.applicants.properties) {
        if (i.indexOf("custom") > -1 && !this.formElem.custom.includes(i)) {
          let name = i.split("_");
          let val = !this.appliData ? "" : this.appliData[i] || "";
          this.form[i] = val;
          this.customFields.push({
            fullName: i,
            index: Number(name[0].replace("custom", "")),
            ...this.session.applicants.properties[i],
            label: name[1],
            name: i,
            value: val
          });
        }
        name.push(i);
      }
      this.customFields = this.customFields.sort((a, b) => a.index - b.index);
      this.customFields.forEach(c => {
        this.formElem.custom.push(c.fullName);
      });
      let step = [];
      for (var key in this.formElem) {
        this.formElem[key].forEach(v => {
          if (name.includes(v) && !step.includes(key)) {
            step.push(key);
          }
        });
      }
      this.steps = [...step];

      this.appliData = {
        ...this.appliData,
        ...this.applicant,
        ticket: this.applicant.ticketName,
        ticketName: this.applicant.ticketName,
        index: this.applicant.index
      };
      // this.appliData[i] = ''
    }
  },
  beforeMount() {
    let step = [];
    let name = [];
    for (var i in this.session.applicants.properties) {
      if (i.indexOf("custom") > -1 && !this.formElem.custom.includes(i)) {
        let name = i.split("_");
        let val = !this.appliData ? "" : this.appliData[i] || "";
        this.form[i] = val;
        this.customFields.push({
          fullName: i,
          index: Number(name[0].replace("custom", "")),
          ...this.session.applicants.properties[i],
          label: name[1],
          name: i,
          value: val
        });
      }
      name.push(i);
    }
    this.customFields = this.customFields.sort((a, b) => a.index - b.index);
    this.customFields.forEach(c => {
      this.formElem.custom.push(c.fullName);
    });

    for (var key in this.formElem) {
      this.formElem[key].forEach(v => {
        if (name.includes(v) && !step.includes(key)) {
          step.push(key);
        }
      });
    }

    this.steps = [...step];
  },
  mounted() {
    if (this.$refs.idNumberInput) {
      const $elm = this.$refs.idNumberInput.$el.querySelector("input");
      $elm.addEventListener("input", e => {
        e.preventDefault();
        this.form.identityNumber = e.target.value.toUpperCase();
      });
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep {
  .v-date-picker-table {
    .v-btn.v-date-picker-table__current {
      border: 0 !important;
      padding: 0 !important;
      background: none !important;

      &::before,
      &::after {
        display: none !important;
      }
    }
  }

  .v-input--radio-group__input {
    flex-wrap: wrap;

    legend {
      width: 100%;
      margin-bottom: 8px;
    }
  }

  .is-phone-lock {
    float: right;
    margin-top: -29px;
    opacity: 0.6;
  }

  .vue-phone-number-input {
    .country-selector__label {
      font-size: 12px;
    }

    .dots-text {
      color: black;
    }

    .input-tel.is-disabled .input-tel__input,
    .country-selector.is-disabled .country-selector__input {
      background: none;
    }

    label {
      font-size: 16px;
    }

    .country-selector__input,
    .input-tel__input {
      border: 0;
    }

    .input-tel__label,
    .country-selector__label,
    .country-selector__country-flag {
      left: 0;
    }

    .country-selector__country-flag {
      bottom: 26px;
    }

    .country-selector__input {
      padding-left: 24px;
    }

    input {
      font-size: 16px;
      border: 0 !important;
      border-bottom: 1px solid #9a9a9a !important;
      box-shadow: none;
      padding: 8px 0;
      outline: none !important;
      border-radius: 0 !important;
    }

    .country-selector,
    .input-tel {
      &.is-valid .input-tel__label,
      &.is-valid .country-selector__label {
        color: rgba(0, 0, 0, 0.6) !important;
      }

      &.has-error:not(.is-valid) .input-tel__input {
        border-color: #ff4500 !important;
      }

      &.has-hint .input-tel__label,
      &.has-value .input-tel__label,
      &.has-hint .country-selector__label,
      &.has-value .country-selector__label {
        transform: translateY(-8px);
      }

      &::after {
        content: "";
        position: absolute;
        left: 0;
        right: 0;
        display: block;
        bottom: -1px;
        margin: auto;
        width: 0px;
        height: 2px;
        background: black;
        transition: all 0.3s ease;
      }

      &.is-focused {
        border: 0;
        outline: none;

        input {
          border: 0 !important;
          border-bottom: 1px solid #9a9a9a !important;
          box-shadow: none !important;
        }

        .input-tel__label,
        .country-selector__label {
          color: $primary-1;
        }

        &::after {
          background-color: $primary-1;
          width: 100%;
        }
      }
    }

    &.error--text {
      .country-selector,
      .input-tel {
        .input-tel__label {
          color: #ff0032 !important;
        }
      }
    }
  }

  .expansion-container {
    display: block !important;
    width: 100%;
    max-width: 750px;
    margin: 0 auto 80px;
  }

  .v-dialog {
    position: relative;
    max-width: 1200px !important;

    .v-expansion-panel-header[disabled] {
      cursor: default;
    }

    .expansion-action {
      text-align: right;
    }

    > div {
      .v-expansion-panels,
      .v-expansion-panel {
        overflow: visible !important;
      }
    }

    .country-selector__list {
      max-height: 180px !important;
    }

    @media screen and (max-width: 600px) {
      width: 100% !important;
      height: 100%;
      max-height: 100%;
      margin: 0;
      -webkit-overflow-scrolling: touch;

      > div {
        height: 100%;
        padding-left: 15px !important;
        padding-right: 15px !important;
        padding-top: 56px !important;

        .v-expansion-panel .v-expansion-panel-header {
          padding: 0 15px !important;
        }

        .v-expansion-panel .v-expansion-panel-content {
          padding: 0 0 24px !important;

          .v-expansion-panel-content__wrap {
            padding: 0 15px !important;
          }

          .input-tel__label {
            display: block;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }

          .container {
            padding: 0 !important;
          }

          .v-input--selection-controls {
            margin-top: 0;
          }
        }

        .text-title {
          font-size: 1rem;
        }

        .expansion-action {
          text-align: center;
          margin-top: 24px;
        }

        .expansion-container {
          margin-left: -15px;
          margin-right: -15px;
          padding-top: 16px;
          width: calc(100% + 30px) !important;
        }
      }
    }

    .close {
      position: absolute;
      font-size: 32px;
      width: 48px;
      height: 48px;
      text-align: center;
      line-height: 48px;
      right: 0;
      top: 0;
    }
  }

  .vue-country-list-wrap {
    min-width: 120px;
  }

  .vue-country-list-wrap .vue-country-list {
    list-style: none;
    padding: 0;

    @media screen and (max-width: 600px) {
      .vue-country-item .vue-country-name {
        display: none;
      }
    }
  }

  .v-expansion-panel .v-expansion-panel-content {
    padding: 0 100px;

    @media screen and (max-width: 600px) {
      padding: 0 0 24px;
    }
  }

  .v-expansion-panels {
    border-radius: 4 !important;
    display: block;
    overflow: hidden;
    box-shadow: 0 3px 7px 0 rgba(0, 0, 0, 0.15);

    .v-expansion-panel {
      border-radius: 0 !important;
      box-shadow: none;

      .v-expansion-panel-header .v-expansion-panel-header__icon .v-icon {
        color: $primary-dark !important;
      }
    }
  }

  .v-expansion-panel.v-expansion-panel--active.v-item--active,
  .v-expansion-panel.v-expansion-panel--active.v-item--active
    + .v-expansion-panel {
    margin-top: 0;
    border-radius: 0 !important;
  }
}
</style>
